export default function TeamStock() {
  return (
    <section className="flex flex-col gap-4 align-middle items-center">
      <h1>Stock Page</h1>
      <p>Coming Soon</p>
    </section>
  );
}
